import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProofOfDeliveryPdfService } from '../../proof-of-delivery/proof-of-delivery-pdf.service';
import { BlobStorageService } from '../../blob-storage/blob-storage.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { QuantityTypesEnum } from './models/quantity-types.enum';

@Component({
  selector: 'app-order-pallet-label-modal',
  standalone: true,
  imports: [ReactiveFormsModule, NgSelectModule],
  templateUrl: './order-pallet-label-modal.component.html',
  styleUrl: './order-pallet-label-modal.component.scss'
})
export class OrderPalletLabelModalComponent implements OnInit {

  @Input()
  order: any | null = null;

  orderPalletLabelsForm: FormGroup | undefined = undefined;

  quantityTypes: any[] = [{ name: "Pallets", typeId: 1 }, { name: "Units", typeId: 2 }, { name: "Enter number of labels", typeId: 3 }];

  constructor(protected activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private proofOfDeliveryPdfService: ProofOfDeliveryPdfService,
    private blobStorageService: BlobStorageService) { }

  ngOnInit() {
    this.initializeForm();
    this.onPalletLabelTypeChange(QuantityTypesEnum.Pallets);
  }

  initializeForm() {
    this.orderPalletLabelsForm = this.formBuilder.group({
      quantityType: this.formBuilder.control(QuantityTypesEnum.Pallets, [Validators.required]),
      numberOfLabels: this.formBuilder.control(0, [Validators.required])
    })
  }

  onPalletLabelTypeChange(typeId: number) {
    let numberOfLabels = 0;
    if (typeId === QuantityTypesEnum.Pallets) {
      numberOfLabels = this.order.pallet;
    } else if (typeId === QuantityTypesEnum.Units) {
      numberOfLabels = this.order.units;
    }
    this.orderPalletLabelsForm?.patchValue({ numberOfLabels: numberOfLabels });
  }

  printLabels() {
    if (this.orderPalletLabelsForm?.valid && this.order) {
      if (this.orderPalletLabelsForm?.value.numberOfLabels > 0) {
        this.printOrderPalletLabel(this.order.orderId, this.orderPalletLabelsForm?.value.numberOfLabels);
      }

      this.activeModal.close();
    }
  }

  printOrderPalletLabel(orderId: number, numberOfLabels: number) {
    this.proofOfDeliveryPdfService.printOrderPalletLabel(orderId, numberOfLabels).subscribe({
      next: (response) => {
        if (response) {
          this.blobStorageService.downloadFile(response.fileBytes, response.fileName);
        }
      },
      error: (response: HttpErrorResponse) => {
        console.error(response.message, 'An error occurred:');
      }
    });
  }
}
